import {
  AddCircleRounded,
  DownloadSharp,
  RemoveCircleRounded,
  RemoveRedEye
} from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  IconButton,
  Modal,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import Select from "react-select";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { getWalletHistoryApi } from "src/api/commonapi";
import Page from "src/components/Page";
import { Routes } from "src/constant/api_url";
import { saveAs } from "file-saver";
import { notification } from "src/utils/messages";
import WalletPayment from "./walletPayment";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import WalletStatusChangeModal from "./walletStatusChangeModal";
import { IsNotValue } from "src/constant/variable";
import { getSetting } from "src/api/updateSetting";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import moment from "moment";
import CustomLoader from "src/commonComponents/CustomLoader";

export default function StockWalletHistory() {
  const user = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();
  const { state } = useLocation();

  const [isLoading, setIsLoading] = useState(false);

  const [walletHistory, setWalletHistory] = useState([]);
  const [totalPendingAmount, setTotalPendingAmount] = useState(0);
  const [totalCaptureAmount, setTotalCaptureAmount] = useState(0);
  const [paymentModal, setPaymentModal] = useState(false);
  const [attachmentData, setAttachmentData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [filterData, setFilterData] = useState({
    type: -1,
    start_date: null,
    e_date: null
  });
  const [walletStatusChangeModal, setWalletStatusChangeModal] = useState(false);
  const [viewAttachmentModal, setViewAttachmentModal] = useState(false);
  const [viewPaymentQrModal, setViewPaymentQrModal] = useState(false);
  const toggleWalletStatusChangeModal = () => setWalletStatusChangeModal(!walletStatusChangeModal);
  const [getdata, setgetdata] = useState({});

  const togglePaymentModal = () => setPaymentModal(!paymentModal);
  const toggleViewAttachmentModal = () => setViewAttachmentModal(!viewAttachmentModal);
  const toggleViewPaymentQrModal = () => setViewPaymentQrModal(!viewPaymentQrModal);

  const statusList = [
    { label: "All", value: -1 },
    { label: "Pending", value: 0 },
    { label: "Captured", value: 1 }
  ];

  const handleGetWalletHistory = async (data) => {
    setIsLoading(true);

    // Callers that only refresh after a mutation (e.g. the Capture Amount modal)
    // invoke this with no arguments. Fall back to the filters currently applied in
    // the UI so the refetch is not silently unfiltered.
    const filter = data ?? filterData;

    const resp = await getWalletHistoryApi({
      p_user_id: state
        ? user?.u_type === 1 || (user?.u_type === 2 && user?.p_user_id !== 1)
          ? state?.p_user_id
          : state?.u_id
        : user?.u_type === 2
          ? user?.p_user_id
          : user?.u_id,
      type: filter?.type,
      start_date: filter?.start_date,
      end_date: filter?.e_date ?? filter?.end_date
    });
    setIsLoading(false);
    setWalletHistory(resp?.data?.data || []);
    setTotalPendingAmount(resp?.data?.stock_pending_balance || 0);
    setTotalCaptureAmount(resp?.data?.stock_captured_amount || 0);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
  };

  async function handleGetWebsetting() {
    try {
      const resp = await getSetting();
      if (resp.status == 1) {
        setgetdata(resp.data);
      }
    } catch {}
  }

  useEffect(() => {
    handleGetWalletHistory(filterData);
  }, []);

  useEffect(() => {
    handleGetWebsetting();
  }, []);

  const conditionalRowStyles = [
    {
      // Pending in either of its two forms: an unapproved payout claim (type 1,
      // status 0) and an entry the city has paid but the admin has not captured yet
      // (status 2). Both read as "Pending" in the Status column, so both are yellow.
      when: (row) =>
        (row?.type === 1 && row?.status === 0) || row?.status === 2,
      style: {
        backgroundColor: "#FFF9C4", // light yellow
        color: "#000"
      }
    },
    {
      when: (row) => row?.type === 0 && row?.status === 0,
      style: {
        backgroundColor: "#FF6363", // light red - amount in
        color: "#000"
      }
    },
    {
      // Captured entries are always green, regardless of type. This rule must stay
      // last: react-data-table-component applies the LAST matching conditional style,
      // so an earlier type-based rule would otherwise override it.
      when: (row) => row?.status === 1,
      style: {
        backgroundColor: "#86f2baff", // light green
        color: "#000"
      }
    }
  ];

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row) => row.c_s_w_id,
      sortable: true,
      width: "100px"
    },
    {
      name: "Product Name",
      wrap: true,
      selector: (row) => row.p_name,
      sortable: true
    },
    {
      name: "Member Name/Guest Name",
      wrap: true,
      selector: (row) =>
        row?.type === 0 && row?.m_id === 0
          ? row?.assign_name != null
            ? row?.assign_name
            : "Courier Charge"
          : row?.type === 1
            ? user?.u_type === 0
              ? "Receive"
              : "Pay Out"
            : row.m_name
    },
    {
      name: "Date",
      wrap: true,
      selector: (row) => row.date,
      sortable: true
    },
    {
      name: "Amount",
      wrap: true,
      selector: (row) => row.amount,
      sortable: true
    },
    {
      name: "Status",
      wrap: true,
      selector: (row) => (row.status === 1 ? "Captured" : "Pending"),
      sortable: true
    },
    // {
    //   name: "Note",
    //   wrap: true,
    //   selector: (row) => row.note,
    //   sortable: true
    // },
    {
      name: "In/Out",
      wrap: true,
      cell: (row) => (
        <>
          {user?.u_type === 1 || (user?.u_type === 2 && user?.p_user_id !== 1) ? (
            <Icon>
              {row.type == 0 && row.m_id != 0 ? (
                <AddCircleRounded color="success" />
              ) : (
                <RemoveCircleRounded color="error" />
              )}
            </Icon>
          ) : (
            ""
          )}
          {row.p_invoice != null && (
            <a
              onClick={() => {
                saveAs(`${Routes.API_HOSTNAME}paid-invoice/${row.p_invoice}`, `${row.p_invoice}`);
              }}
            >
              <Tooltip title="Download Invoice">
                <IconButton>
                  <DownloadSharp color="info" />
                </IconButton>
              </Tooltip>
            </a>
          )}
          {(user?.u_type === 0 || (user?.u_type === 2 && user?.p_user_id === 1)) &&
          row?.type === 1 &&
          row?.status === 0 ? (
            <Tooltip title="Capture Amount">
              <IconButton
                onClick={() => {
                  setRowData(row);
                  toggleWalletStatusChangeModal();
                }}
              >
                <Icon
                  icon="solar:hand-money-broken"
                  width={22}
                  height={22}
                  style={{ color: "green" }}
                />
              </IconButton>
            </Tooltip>
          ) : (
            ""
          )}

          <Tooltip title="View Attachments">
            <IconButton
              onClick={() => {
                setAttachmentData(row);
                toggleViewAttachmentModal();
              }}
            >
              <RemoveRedEye color="light" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  const ExpandableRow = ({ data }) => {
    return (
      <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
        {data?.note != null && data?.note != "" && (
          <p>
            <b> Note</b> : {data?.note}
          </p>
        )}
      </div>
    );
  };

  return (
    <>
      <Page title="Wallet History | Local Vocal Business Group">
        <Container>
          {(user?.u_type === 1 || (user?.u_type === 2 && user?.p_user_id !== 1)) && getdata && (
            <Card sx={{ mb: 2, p: 2 }}>
              <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                {/* Bank Details */}
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" mb={1}>
                    Bank Details
                  </Typography>

                  <Typography variant="body2">
                    <b>Bank Name:</b> {getdata.bank_name || "-"}
                  </Typography>
                  <Typography variant="body2">
                    <b>Account Holder:</b> {getdata.ac_holder_name || "-"}
                  </Typography>
                  <Typography variant="body2">
                    <b>Account No:</b> {getdata.account_no || "-"}
                  </Typography>
                  <Typography variant="body2">
                    <b>IFSC Code:</b> {getdata.ifsc_code || "-"}
                  </Typography>
                </Box>
                <Modal
                  open={viewPaymentQrModal}
                  onClose={() => toggleViewPaymentQrModal()}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 400,
                      bgcolor: "background.paper",
                      boxShadow: 24,
                      p: 3,
                      borderRadius: 2,
                      height: "400px",
                      overflow: "auto"
                    }}
                  >
                    <Typography variant="h6" mb={2}>
                      Payment QR
                    </Typography>

                    {getdata.payment_qr_code ? (
                      <>
                        {/* <Box
                          sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
                        >
                          <Typography variant="subtitle1">Payment QR</Typography>
                          <Button
                            size="small"
                            variant="outlined"
                            sx={{ mt: 1 }}
                            onClick={() =>
                              saveAs(
                                `${Routes.API_HOSTNAME}dispatch-form/${attachmentData.dispatch_form}`,
                                attachmentData.dispatch_form
                              )
                            }
                          >
                            Download
                          </Button>
                        </Box> */}
                        {getdata.payment_qr_code && (
                          <Box mb={2}>
                            <img
                              src={`${Routes.API_HOSTNAME}payment-qr-code/${getdata.payment_qr_code}`}
                              alt="Payment QR"
                              style={{
                                borderRadius: 8,
                                marginTop: 5,
                                width: "300px",
                                height: "300px",
                                objectFit: "contain"
                              }}
                            />
                          </Box>
                        )}
                      </>
                    ) : (
                      <p style={{ display: "flex", justifyContent: "center", textAlign: "center" }}>
                        There are no attachment
                      </p>
                    )}
                  </Box>
                </Modal>

                {/* OR Divider */}

                {/* QR Code */}
                <Box sx={{ textAlign: "center" }}>
                  {/* <Typography variant="h6" mb={1}>
                    Scan & Pay
                  </Typography> */}

                  {getdata.payment_qr_code ? (
                    <img
                      src={`${Routes.API_HOSTNAME}payment-qr-code/${getdata.payment_qr_code}`}
                      alt="Payment QR"
                      style={{
                        width: 150,
                        height: 150,
                        objectFit: "contain",
                        border: "1px solid #ddd",
                        borderRadius: 8,
                        cursor: "pointer"
                      }}
                      onClick={() => {
                        // setAttachmentData();
                        toggleViewPaymentQrModal();
                      }}
                    />
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      QR Code not available
                    </Typography>
                  )}
                </Box>
              </Stack>
            </Card>
          )}
          <Stack spacing={2} mb={2}>
            {/* Title */}
            <Typography variant="h4">Wallet History</Typography>

            {/* Main Row */}
            <Stack
              direction={{ xs: "column", md: "row" }}
              spacing={2}
              alignItems={{ xs: "stretch", md: "center" }}
              justifyContent="space-between"
            >
              {/* LEFT SIDE – Filters */}
              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={2}
                alignItems={{ xs: "stretch", md: "center" }}
                flexWrap="wrap"
                flex={1}
              >
                <Stack>
                  <label>Select Payment Status</label>
                  {/* Status Select */}
                  <Select
                    placeholder="Select Payment Status"
                    options={statusList}
                    value={statusList.find((c) => c.value === filterData.type) || null}
                    onChange={(e) => setFilterData({ ...filterData, type: e.value })}
                    styles={{
                      container: (base) => ({
                        ...base,
                        minWidth: 220,
                        width: 300
                      })
                    }}
                  />
                </Stack>

                <Stack>
                  <LocalizationProvider dateAdapter={AdapterDateFns} style={{ marginTop: "0px" }}>
                    <label style={{ marginBottom: "5px" }}>Select Start Date</label>
                    <DatePicker
                      type="date"
                      name="s_date"
                      inputFormat="dd/MM/yyyy"
                      value={
                        filterData.start_date != null
                          ? moment(filterData.start_date, "DD-MM-YYYY")
                          : null
                      }
                      onChange={(newDate) => {
                        setFilterData({
                          ...filterData,
                          start_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                        });
                      }}
                      renderInput={(params) => <TextField {...params} size="small" />}
                    />
                  </LocalizationProvider>
                </Stack>
                <Stack>
                  <LocalizationProvider dateAdapter={AdapterDateFns} style={{ marginTop: "0px" }}>
                    <label style={{ marginBottom: "5px" }}>Select End Date</label>
                    <DatePicker
                      type="date"
                      name="e_date"
                      inputFormat="dd/MM/yyyy"
                      value={
                        filterData.e_date != null ? moment(filterData.e_date, "DD-MM-YYYY") : null
                      }
                      onChange={(newDate) => {
                        setFilterData({
                          ...filterData,
                          e_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                        });
                      }}
                      renderInput={(params) => <TextField {...params} size="small" />}
                    />
                  </LocalizationProvider>
                </Stack>

                {/* Search & Clear Buttons */}
                <Stack direction="row" spacing={1} style={{ marginTop: "20px" }}>
                  <Button
                    variant="contained"
                    onClick={() => handleGetWalletHistory(filterData)}
                    disabled={isLoading}
                    startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                  >
                    Search
                  </Button>

                  <Button
                    variant="contained"
                    color="inherit"
                    onClick={() => {
                      setFilterData({ type: -1, start_date: null, e_date: null });
                      handleGetWalletHistory({ type: -1, start_date: null, e_date: null });
                    }}
                  >
                    Clear
                  </Button>
                </Stack>
              </Stack>

              {/* RIGHT SIDE – Back Button */}
              {(user?.u_type === 0 || (user?.u_type === 2 && user?.p_user_id === 1)) && (
                <Stack
                  alignItems={{ xs: "stretch", md: "flex-end" }}
                  mt={{ xs: 1, md: 0 }}
                  style={{ marginTop: "20px" }}
                >
                  <Button
                    variant="contained"
                    onClick={() => navigate("/citywallet", { replace: true })}
                  >
                    Back
                  </Button>
                </Stack>
              )}
            </Stack>
          </Stack>

          <Card>
            {user?.u_type === 1 || (user?.u_type === 2 && user?.p_user_id !== 1) ? (
              <Stack direction="row" alignItems="center" justifyContent="end" gap={1} spacing={2}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    backgroundColor: "#87c773",
                    padding: "6px 12px",
                    borderRadius: 1,
                    fontWeight: 600
                  }}
                >
                  Total Captured Amount: ₹ {totalCaptureAmount}
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    backgroundColor: "#efefa2",
                    padding: "6px 12px",
                    borderRadius: 1,
                    fontWeight: 600
                  }}
                >
                  Total Pending Amount: ₹ {totalPendingAmount}
                </Typography>
                <Button
                  style={{ marginBottom: "10px", padding: "7px" }}
                  variant="contained"
                  className="btn test btn-export"
                  onClick={() => {
                    // setRowData(row);
                    togglePaymentModal();
                  }}
                >
                  Add Payment
                </Button>
              </Stack>
            ) : (
              ""
            )}
            <DataTable
              filter
              pagination
              highlightOnHover
              expandableRows
              expandableRowsComponent={ExpandableRow}
              columns={columns}
              data={walletHistory}
              conditionalRowStyles={user?.u_type === 0 && conditionalRowStyles}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
            />
          </Card>
        </Container>
      </Page>

      {paymentModal && (
        <WalletPayment
          paymentModal={paymentModal}
          togglePaymentModal={togglePaymentModal}
          handleCityWiseWalletList={handleGetWalletHistory}
          filterData={filterData}
        />
      )}

      {walletStatusChangeModal && (
        <WalletStatusChangeModal
          walletStatusChangeModal={walletStatusChangeModal}
          toggleWalletStatusChangeModal={toggleWalletStatusChangeModal}
          rowData={rowData}
          handleCityWiseWalletList={handleGetWalletHistory}
          filterData={filterData}
        />
      )}

      <Modal
        open={viewAttachmentModal}
        onClose={() => toggleViewAttachmentModal()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2
          }}
        >
          <Typography variant="h6" mb={2}>
            Attachments
          </Typography>

          {/* Dispatch Form */}
          {!IsNotValue.includes(attachmentData?.p_screenshot) ? (
            <>
              {/* Payment Screenshot */}
              {attachmentData?.p_screenshot && (
                <Box mb={2}>
                  <Box
                    sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
                  >
                    <Typography variant="subtitle1">Payment Screenshot</Typography>
                    <Button
                      size="small"
                      variant="outlined"
                      sx={{ mt: 1 }}
                      onClick={() =>
                        saveAs(
                          `${Routes.API_HOSTNAME}paid-screenshot/${attachmentData.p_screenshot}`,
                          attachmentData.p_screenshot
                        )
                      }
                    >
                      Download
                    </Button>
                  </Box>
                  <img
                    src={`${Routes.API_HOSTNAME}paid-screenshot/${attachmentData.p_screenshot}`}
                    alt="Receipt"
                    style={{
                      borderRadius: 8,
                      marginTop: 5,
                      width: "150px",
                      height: "150px",
                      objectFit: "contain"
                    }}
                  />
                </Box>
              )}
            </>
          ) : (
            <p style={{ display: "flex", justifyContent: "center", textAlign: "center" }}>
              There are no attachment
            </p>
          )}
        </Box>
      </Modal>
    </>
  );
}
